module.exports = __webpack_public_path__ + "img/4.28b4b8a3.svg";